import React, { useContext } from 'react';
import {Heart, HeartFilled} from '@volkswagen-onehub/icons-core';
import {
  CTA,
  styled,
  Text,
  TextTag,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import {useFavouritesStore} from '../../../store/favourites';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {getLang, getTranslations} from '../../../translations';
import {useFeatureServices} from '../../../use-feature-services';
import {
  createConfiguration,
  createConstantData,
  createPartner,
  createProcess,
} from '../../../utils/get-tracking-event-data';
import {getSingleSelectedDealer} from '../../../utils/get-single-selected-dealer';
import FavouritesCounter from '../../../Favourites/FavouritesCounter';
import {Route} from '../../../utils/use-route';
import { AppContext } from '../../../app-context';

const FavouriteCTA = styled(CTA)`
  display: flex;

  span {
    display: flex;
    align-items: center;
    column-gap: ${(props) => props.theme.size.dynamic0020};
    &:first-child {
      text-decoration: underline 1px;
    }
    &:last-child {
      text-decoration: none !important;
    }
  }
`;

export const FavouritePage = () => {
  const [searchParams] = useSearchParams();
  const {tracking} = useFeatureServices();
  const {favourites} = useFavouritesStore();
  const navigate = useNavigate();
  const partner = getSingleSelectedDealer();
  const { pageBaseUrl } = useContext(AppContext);

  const goToFavourite = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault();
    tracking.track('VWBasic_VehicleButton_Click', {
      ...createConstantData(),
      configuration: createConfiguration(),
      partner: createPartner(partner),
      process: createProcess('2A'),
      link: {
        url: e.currentTarget.href,
        name: e.currentTarget.innerText,
      },
    });
    navigate({pathname: '/favourites'});
  };

  const getIcon = () =>
    favourites?.vins?.length ? (
      <HeartFilled ariaHidden />
    ) : (
      <Heart ariaHidden />
    );

  const trans = getTranslations();

  const lang = getLang();

  return (
    <FavouriteCTA
      href={
        pageBaseUrl?.dispatcher[lang] +
        '/' +
        Route.FAVOURTIES +
        (searchParams.toString() && '?' + searchParams.toString())
      }
      iconPosition="end"
      disabled={!favourites?.vins?.length}
      tag="a"
      emphasis="tertiary"
      ariaLabel={trans.labels.favourites + favourites?.vins?.length}
      onClick={(e) => goToFavourite(e)}
    >
      <Text tag={TextTag.span} color={TokenTextColor.inherit}>
        {trans.labels.favourites}
      </Text>{' '}
      {getIcon()} <FavouritesCounter />
    </FavouriteCTA>
  );
};
